import { FC } from 'react'

import { INutrientRow } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

import {
  NutrientAmountCell,
  NutrientLabelCell,
  NutrientRowContainer,
  NutrientTableContainer,
  NutrientUnitCell,
} from './styled'

type NutrientTableProps = {
  rows: INutrientRow[]
}

// QRM-640: Bezeichnung / Anzahl / Einheit like the SmartCheckout dialog.
// Header rows ("davon:") come with amount: null and an empty unit — label only.
export const NutrientTable: FC<NutrientTableProps> = ({ rows }) => (
  <NutrientTableContainer data-testid="nutrient_table">
    {rows.map((row, idx) => (
      <NutrientRowContainer key={`nutrient_${row.code}_${idx}`}>
        <NutrientLabelCell>{row.label}</NutrientLabelCell>
        <NutrientAmountCell>
          {row.amount === null ? '' : `${row.amount}`}
        </NutrientAmountCell>
        <NutrientUnitCell>{row.unit}</NutrientUnitCell>
      </NutrientRowContainer>
    ))}
  </NutrientTableContainer>
)
